import styled from "styled-components";
import { media } from "../../../../utils/breakpoints";

export const InteractionPaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  /* Fill the MiddleColumn (clamps fluidly to viewport). */
  width: 100%;
  /* Fill the column so Call Vehicle + Map View can flex 2:1 to share it. */
  height: 100%;
  color: #606060;

  ${media.tablet} {
    width: 100%;
  }

  ${media.portrait} {
    /* Flatten so the button / map / error become items of the parent grid in
       TopControlPanelStyled (areas: call / map / err). */
    display: contents;
  }
`;

export const CallVehicleButtonStyled = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  /* Fill the column (MiddleColumn clamps fluidly). */
  width: 100%;
  /* 2:1 with MapView; min-height keeps it tappable on short headers. */
  flex: 2 1 0;
  min-height: 56px;
  padding: 16px 24px;
  background: #3f7f7d;
  border: none;
  cursor: pointer;

  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  /* 20px on tablet → grows toward 28px on desktop. */
  font-size: clamp(20px, 1.6vw, 28px);
  line-height: 120%;
  color: #ffffff;

  &:disabled {
    cursor: not-allowed;
    background: #d6d8de;
    color: #606060;
    border: none;

    svg {
      path {
        stroke: #606060;
      }
    }
  }

  ${media.tablet} {
    width: 100%;
    font-size: 18px;
  }

  ${media.portrait} {
    grid-area: call;
    width: auto;
    height: 72px;
    font-size: 18px;
  }
`;

export const EmptyErrorStyled = styled.div`
  color: red;
  font-weight: 500;

  ${media.portrait} {
    grid-area: err;
  }
`;

export const MapViewStyled = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  /* Fill the column (MiddleColumn clamps fluidly). */
  width: 100%;
  /* 1:2 with CallVehicle. */
  flex: 1 1 0;
  min-height: 36px;
  padding: 8px 16px;
  border: 2px solid #3f7f7d;
  color: #3f7f7d;
  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  font-size: clamp(20px, 1.6vw, 28px);
  line-height: 120%;
  cursor: pointer;

  ${media.tablet} {
    width: 100%;
    padding: 6px 16px;
    font-size: 16px;
  }

  ${media.portrait} {
    grid-area: map;
    width: auto;
    height: 48px;
    padding: 8px 16px;
    font-size: 18px;
  }
`;
